export class Customers {
  id: bigint;
  name: string;
  vat_reg: string;
  postal_code: string;
  addr1: string;
  addr2: string;
  city: string;
  province: string;
  country: string;
  tel: string;
  email: string;
  annotation: string;
  delivery_route: number;
  user_id: number;
  orig_id: string;
  iban: string;
  sepa: number;
  sepa_date: any;
  debt_past: number;
  debt_fut: number;
  pay_past: number;
  pay_fut: number;
  acc_nr: string;
}
